<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="3" md="3" v-for="cat in schema">
        <v-card min-height="200" class="fill-height">
          <v-spacer>
            <div class="text-center">
              <v-card-title><h3>{{ cat['name'] }}</h3></v-card-title>
              <v-list>
                <div style="display: inline-flex; flex-direction: column">
                  <v-btn v-for="r in cat.routes" @click="routeTo(r['route'])" style="margin-bottom: 4px">
                    {{ r['name'] }}
                  </v-btn>
                </div>
              </v-list>
            </div>
          </v-spacer>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { schema } from '../router/pages';
import { useRouter } from "vue-router";

const router = useRouter();

async function routeTo(route) {
  await router.push(route);
}
</script>

<style scoped>

</style>
